/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import t from "../../TimeExtent.js";
import r from "../../TimeInterval.js";
import { property as o } from "../../core/accessorSupport/decorators/property.js";
import "../../core/accessorSupport/ensureType.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import { reader as s } from "../../core/accessorSupport/decorators/reader.js";
import { subclass as i } from "../../core/accessorSupport/decorators/subclass.js";
import { fixTimeInfoFields as p } from "../support/fieldUtils.js";
import m from "../support/TimeInfo.js";
import { timeUnitKebabDictionary as n } from "../../portal/timeUnitKebabDictionary.js";
const a = a => {
  let f = class extends a {
    constructor() {
      super(...arguments), this.timeExtent = null, this.timeOffset = null, this.useViewTime = !0;
    }
    readOffset(e, t) {
      const o = t.timeInfo.exportOptions;
      if (!o) return null;
      const s = o.timeOffset,
        i = n.fromJSON(o.timeOffsetUnits);
      return s && i ? new r({
        value: s,
        unit: i
      }) : null;
    }
    set timeInfo(e) {
      p(e, this.fieldsIndex), this._set("timeInfo", e);
    }
  };
  return e([o({
    type: t,
    json: {
      write: !1
    }
  })], f.prototype, "timeExtent", void 0), e([o({
    type: r
  })], f.prototype, "timeOffset", void 0), e([s("service", "timeOffset", ["timeInfo.exportOptions"])], f.prototype, "readOffset", null), e([o({
    value: null,
    type: m,
    json: {
      write: !0,
      origins: {
        "web-document": {
          read: !1,
          write: !1
        },
        "portal-item": {
          read: !1,
          write: !1
        }
      }
    }
  })], f.prototype, "timeInfo", null), e([o({
    type: Boolean,
    json: {
      read: {
        source: "timeAnimation"
      },
      write: {
        target: "timeAnimation"
      },
      origins: {
        "web-scene": {
          read: !1,
          write: !1
        }
      }
    }
  })], f.prototype, "useViewTime", void 0), f = e([i("esri.layers.mixins.TemporalLayer")], f), f;
};
export { a as TemporalLayer };